import React from 'react';
import { Sparkles, Clock, Brain } from 'lucide-react';

export function WelcomeStep() {
  return (
    <div className="text-center max-w-lg mx-auto">
      <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <Brain className="w-8 h-8 text-blue-600" />
      </div>

      <h2 className="text-2xl font-bold text-gray-900 mb-3">
        Define Your Coaching DNA
      </h2>

      <p className="text-gray-600 mb-8">
        Tell us about your coaching philosophy, preferred formations, and training approach.
        We'll use this to generate personalised development plans tailored to your style.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-left">
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mb-2">
            <Clock className="w-4 h-4 text-blue-600" />
          </div>
          <h4 className="text-sm font-semibold text-gray-900 mb-1">Quick Setup</h4>
          <p className="text-xs text-gray-500">Takes less than 2 minutes to complete</p>
        </div>

        <div className="bg-gray-50 rounded-lg p-4">
          <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mb-2">
            <Sparkles className="w-4 h-4 text-green-600" />
          </div>
          <h4 className="text-sm font-semibold text-gray-900 mb-1">Personalised</h4>
          <p className="text-xs text-gray-500">Plans tailored to your coaching style</p>
        </div>

        <div className="bg-gray-50 rounded-lg p-4">
          <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center mb-2">
            <Brain className="w-4 h-4 text-purple-600" />
          </div>
          <h4 className="text-sm font-semibold text-gray-900 mb-1">AI-Powered</h4>
          <p className="text-xs text-gray-500">Intelligent recommendations from your data</p>
        </div>
      </div>

      <p className="text-xs text-gray-400 mt-8">
        You can update your coaching DNA at any time. Your progress is saved automatically.
      </p>
    </div>
  );
}
